export default "__VITE_ASSET__DWUqI$Zp__"